import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CategoryStoreEffects } from './store/category.effects';
import { CategoryStoreService } from './store/category.store.service';
import { SharedModule } from '@shared/shared.module';
import { CategoryCardComponent } from '@modules/category/components/category-card/category-card.component';
import { CategoryFilterComponent } from '@modules/category/pages/category-filter/category-filter.component';
import { categoryFeatureKey } from './store/category.state';
import { categoryStoreReducer } from './store/category.reducer';
import { CategoryResolver } from '@modules/category/resolvers/category.resolver';

@NgModule({
  declarations: [CategoryCardComponent, CategoryFilterComponent],
  imports: [
    SharedModule,
    RouterModule,
    StoreModule.forFeature(categoryFeatureKey, categoryStoreReducer),
    EffectsModule.forFeature([CategoryStoreEffects])
  ],
  exports: [CategoryCardComponent, CategoryFilterComponent],
  providers: [CategoryStoreEffects, CategoryStoreService, CategoryResolver]
})
export class CategoryClientModule {}
